import React, { useEffect, useState } from "react";
import { sendRequest } from "../../util/httpClient";
import { CloseDialogContext, DialogComponent } from "../common/DialogComponent";
import NameAddress from "../Monitoring/NameAddress";
import SexOffender from "../Monitoring/SexOffender";
import { months } from "../../util/CommonLists";
import OpenCaseConfirmation from "./OpenCaseConfirmation";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import { useHistory } from "react-router";
import * as alertActions from "../../store/AlertsService/actions";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../util/dateFormatting";
interface IProps {
    alert: any;
    refresh?: any;
}
const CaseDetails = ({ alert, refresh }: IProps) => {
    const { t: tLang } = useTranslation();
    const [alertDetails, setAlertDetails]: any = useState({});
    const [confirmCase, setConfirmCase] = useState(false);
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [alertIntroMessage, setAlertIntroMessage] = useState("");
    const dispatch = useDispatch();
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const breachDetail = alertDetails.length && alertDetails[0]["alertBreachDetails"] ? alertDetails[0]["alertBreachDetails"] : null;
    const [isTUAlert, setIsTUAlert] = useState(false);
    const [isBreachDetail, setIsBreachDetail] = useState(false);
    const requestAlertDataUpdate = (alertData: any, status: string) => dispatch(alertActions.actionCreators.updateAlertsStatus(alertData, status));
    useEffect(() => {
        if (isTUAlert) {
            document.querySelector<any>(`[aria-labelledby=case-details-dialog-title]`)!.classList.add("width-mxl");
        }
    }, [isTUAlert]);
    useEffect(() => {
        if (alertDetails.length) {
            for (let i = 0; i < alertDetails.length; i++) {
                if (alertDetails[i]["alertBreachDetails"] && alertDetails[i]["alertBreachDetails"]["status"] === "COMPLETED") {
                    setIsBreachDetail(true);
                    break;
                }
            }
        }
    }, [alertDetails]);
    const handleCloseDialog = (): any => {
        setShowConfirmationPopup(false);
    };
    let history = useHistory();
    useEffect(() => {
        if (confirmCase) {
            setLoading(true);
            const melissaVal = {
                isRead: false,
                isArchived: null,
                isOpenCased: null,
                isResolved: true,
            };
            const requestBody = {
                alertItemRequest: [
                    {
                        isIDFAlert: false,
                        alertId: alert.alertID,
                        status: "NOT_MINE_RESOLVED",
                        isMelissaAlert: alert.isMelissaAlert,
                        serviceType: alert.serviceType,
                    },
                ],
                ...(alert.isMelissaAlert === true && { alertUpdateRequest: melissaVal }),
                isChildUser: alert.isChildUser ? alert.isChildUser : false,
                childEmailAddress: alert.childEmailAddress ? alert.childEmailAddress : "",
            };
            sendRequest("post", "api/alerts/updateAlertItem", requestBody)
                .then((data: any) => {
                    setLoading(false);
                    closeDialog();
                    requestAlertDataUpdate(requestBody, "RESOLVEDCASE");
                })
                .catch((error: any) => {
                    console.log({ error });
                    setLoading(false);
                });
        }
    }, [confirmCase]);

    const reopenCase = () => {
        setLoading(true);
        const melissaVal = {
            isRead: false,
            isArchived: null,
            isOpenCased: true,
            isResolved: null,
        };
        const requestBody = {
            alertItemRequest: [
                {
                    isIDFAlert: false,
                    alertId: alert.alertID,
                    status: "NOT_MINE",
                    isMelissaAlert: alert.isMelissaAlert,
                    serviceType: alert.serviceType,
                },
            ],
            ...(alert.isMelissaAlert === true && { alertUpdateRequest: melissaVal }),
            isChildUser: alert.isChildUser ? alert.isChildUser : false,
            childEmailAddress: alert.childEmailAddress ? alert.childEmailAddress : "",
        };
        sendRequest("post", "api/alerts/updateAlertItem", requestBody)
            .then((data: any) => {
                setLoading(false);
                closeDialog();
                requestAlertDataUpdate(requestBody, "OPENCASE");
            })
            .catch((error: any) => {
                console.log({ error });
            });
    };
    useEffect(() => {
        setLoading(true);
        const requestBody = {
            AlertData: [
                {
                    AlertID: alert.alertID,
                    ServiceType: alert.idfAlertType !== null ? "" : alert.serviceType,
                    IDFAlertType: alert.idfAlertType === null ? "" : alert.idfAlertType,
                },
            ],
            isChildUser: alert.isChildUser ? alert.isChildUser : false,
            childEmailAddress: alert.childEmailAddress ? alert.childEmailAddress : "",
        };
        sendRequest("post", "api/alerts/getAlertDetails", requestBody)
            .then((data: any) => {
                setAlertDetails(data._unifiedAlertDetails);
                setIsTUAlert(data._unifiedAlertDetails[0].providerItemType === "Response.TUAlertResponse.Data.Report.Record");
                setLoading(false);
                if (data._unifiedAlertDetails[0].status === "RESOLVEDCASE") {
                    setAlertIntroMessage("introMessageResolvedCase");
                } else if (data._unifiedAlertDetails[0].serviceType === "CRDALRT" && data._unifiedAlertDetails[0].alertDetails.rawContentUrl.length === 0) {
                    setAlertIntroMessage("expiredCreditAlert");
                } else {
                    setAlertIntroMessage("introMessageOpenCase");
                }
            })
            .catch((error: any) => {
                console.log({ error });
            });
    }, []);
    const close: any = React.useContext(CloseDialogContext);
    const closeDialog = () => {
        close("case-details-dialog");
    };

    const getNegativeData = (negativeData: any) => {
        const data = negativeData.alertDetails.alertItemDetails;
        const negativeDataType = data["New Value"].split("|")[0];
        const newValue = Boolean(parseInt(negativeDataType)) ? data["New Value"] : data["New Value"].split("|")[1];
        const previousValue = Boolean(parseInt(negativeDataType)) ? data["Previous Value"] : data["Previous Value"].split("|")[1];
        return { negativeDataType, newValue, previousValue };
    };
    const currencyFormat = (num: any) => {
        //return DFA in US number system
        return (
            "$" +
            parseInt(num)
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        );
    };
    const redirectBreachDetail = () => {
        if (breachDetail) {
            history.push({
                pathname: `/breaches/breach-details`,
                state: { id: breachDetail["breachId"], backPage: "breach_case", orgName: breachDetail["organizationName"], breachDate: breachDetail["breachDate"] },
            });
        }
    };
    return (
        <>
            <div className="dialog-header">
                <div className="dialog-icon status-default">
                    <em className="las la-clipboard"></em>
                </div>
                <h1>{alertDetails[0] && (isBusinessUser ? "Business " : "") + alertDetails[0].title}</h1>
                {alert.alertStatus === "OPENCASE" && alert.alertStatus === "OPENED" && (
                    <div className="case-status open">{tLang("alerts.cases.openStatusTagText")}</div>
                )}
                <div className="case-date">
                    Alert on {alertDetails[0] && alertDetails[0]["createdDate"] && getFormattedDate(i18nService.get("Country"), alert.createdDate)}
                </div>
            </div>
            <div className={`dialog-body ${loading && "loading"}`}>
                <p>
                    {alertIntroMessage === "expiredCreditAlert"
                        ? "Your Credit Monitoring alert case is currently open. Click “Resolve Case” after you are finished working with our Resolution Center."
                        : alertDetails[0] && alertDetails[0].messageContent && alertDetails[0].messageContent[alertIntroMessage]}
                </p>

                {alertDetails[0] &&
                alertDetails[0].messageContent &&
                (alertDetails[0].type !== "Negative data" || alertDetails[0].messageContent.alertHelpContent.type !== "DEFAULT-CONTENT") ? (
                    <>
                        {breachDetail && breachDetail["status"] === "COMPLETED" ? (
                            <div className="data-row row breach-alert-title-main">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <h5 className="breach-alert-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.detialSummary")}</h5>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter text-align-sm-end text-align-right">
                                    <button className="btn-default btn-breach-primary breach-alert-btn-width btn-search-bg-color" onClick={redirectBreachDetail}>
                                        View Full Breach Alert
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <h3 className="content-sub-title margin-bottom-xs">{tLang("alerts.alerts.activeAlertPopup.buttonText.detialSummary")}</h3>
                        )}

                        <div role="grid" className="data-grid has-lines row-height-sm" id="case1-details-content" aria-hidden="false">
                            {alert.serviceType === "SEXOFF" || alert.serviceType === "SVC-COAMON"
                                ? alertDetails[0] && <SexOffender alertInfo={alertDetails} />
                                : alertDetails[0] && <NameAddress alertInfo={alertDetails} isTUAlert={isTUAlert} isBreachDetail={isBreachDetail} />}
                            {alert.serviceType === "SEXOFF" && breachDetail && breachDetail["status"] === "COMPLETED" ? (
                                <NameAddress alertInfo={alertDetails} isTUAlert={isTUAlert} isBreachDetail={isBreachDetail} />
                            ) : null}
                        </div>
                    </>
                ) : (
                    <>
                        {alertDetails[0] &&
                            alertDetails[0].alertDetails.alertItemDetails &&
                            Boolean(alertDetails[0].alertDetails.alertItemDetails["New Value"]) &&
                            Boolean(alertDetails[0].alertDetails.alertItemDetails["Previous Value"]) && (
                                <>
                                    <h3 className="content-sub-title margin-bottom-xs">
                                        There has been a change in your Derogatory Filing
                                        {getNegativeData(alertDetails[0]).negativeDataType === "DFA" ? " Amount (DFA)." : " Count (DFC)."}
                                    </h3>

                                    <div className="alert-details-container" id="alert1-details" style={{ marginBottom: "40px" }}>
                                        <div role="grid" className="data-grid has-lines row-height-sm" id="alert1-details-content" aria-hidden="false">
                                            <div role="row" className="data-row row">
                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="alert1-prevValue">
                                                        Previous Value
                                                    </div>
                                                </div>
                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="data-value" aria-labelledby="alert1-prevValue">
                                                        {getNegativeData(alertDetails[0]).negativeDataType === "DFA"
                                                            ? currencyFormat(getNegativeData(alertDetails[0]).previousValue)
                                                            : getNegativeData(alertDetails[0]).previousValue}
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="row" className="data-row row">
                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="alert1-newValue">
                                                        New Value
                                                    </div>
                                                </div>
                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="data-value" aria-labelledby="alert1-newValue">
                                                        {getNegativeData(alertDetails[0]).negativeDataType === "DFA"
                                                            ? currencyFormat(getNegativeData(alertDetails[0]).newValue)
                                                            : getNegativeData(alertDetails[0]).newValue}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {getNegativeData(alertDetails[0]).negativeDataType === "DFA" ? (
                                        <span style={{ marginTop: "50px" }}>
                                            <strong>Derogatory Filing Amount (DFA)</strong> is the total sum of all legal filings past due.
                                        </span>
                                    ) : (
                                        <span style={{ marginTop: "50px" }}>
                                            <strong>Derogatory Filing Count (DFC)</strong> is the total count of all legal filings.
                                        </span>
                                    )}
                                </>
                            )}
                    </>
                )}
            </div>
            <div className="dialog-footer" style={{ paddingTop: breachDetail && breachDetail["status"] === "COMPLETED" ? "unset" : "1.5rem" }}>
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-link btn-no-border btn-no-padding" onClick={() => closeDialog()}>
                            <span className="btn-text">{tLang("alerts.cases.buttonText.close")}</span>
                        </button>
                    </div>
                    {breachDetail && breachDetail["status"] === "COMPLETED" ? null : (
                        <div className="col-xs col-no-gutter flex-grow-null">
                            {alert.alertStatus !== "RESOLVEDCASE" && alert.alertStatus !== "RESOLVED" && (
                                <button
                                    type="button"
                                    className="btn-default btn-primary-outline"
                                    onClick={() => {
                                        setShowConfirmationPopup(true);
                                    }}
                                >
                                    <span className="btn-text">{tLang("alerts.cases.buttonText.resolveCase")}</span>
                                </button>
                            )}
                            {(alert.alertStatus === "RESOLVEDCASE" || alert.alertStatus === "RESOLVED") && (
                                <button
                                    type="button"
                                    className="btn-default btn-primary-outline"
                                    onClick={() => {
                                        reopenCase();
                                    }}
                                >
                                    <span className="btn-text">{tLang("alerts.cases.buttonText.reopenCase")}</span>
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {showConfirmationPopup && (
                <DialogComponent hideCloseButton={true} dialogId="open-case-confirmation" title="Alert Details" closeDialog={handleCloseDialog}>
                    <OpenCaseConfirmation type={"resolveCase"} setConfirmCase={setConfirmCase}></OpenCaseConfirmation>
                </DialogComponent>
            )}
        </>
    );
};

export default CaseDetails;
